import { Component } from "@angular/core";

@Component({
  selector: "competition-form-skeleton",
  templateUrl: "./competition-form-skeleton.component.html",
  styleUrls: ["./competition-form-skeleton.component.scss"],
})
export class CompetitionFormSkeletonComponent {}
